import React from 'react';
import PropTypes from 'prop-types';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import SessionChips from '../../Session/SessionChips';
import SpeakerAvatars from '../../Session/SpeakerAvatars';

const SessionTemplate = ({
  headlineTag,
  items,
  linkTitle,
  linkHref,
  isEditMode,
}) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <UniversalLink href={href}>{linkTitle || href}</UniversalLink>;
  }

  const getTitleTag = (tag) => {
    const level = Number(tag?.slice(-1));
    if (Number.isInteger(level) && level >= 1 && level <= 6) {
      return `h${Math.min(level + 1, 6)}`;
    }
    return 'h3';
  };
  const TitleTag = getTitleTag(headlineTag);

  return (
    <>
      <div className="items session-listing">
        {items.map((item) => {
          const presenters = item.presenters || [];
          const speakersNames = presenters.map((p) => p.title).join(', ');

          return (
            <div className="session-item" key={item['@id']}>
              <ConditionalLink item={item} condition={!isEditMode}>
                <div className="session-item__body listing-body">
                  <SpeakerAvatars presenters={presenters} />

                  <div className="session-item__content">
                    {speakersNames && (
                      <div className="session-item__speakers">
                        {speakersNames}
                      </div>
                    )}

                    <div className="session-item__title-wrapper">
                      <TitleTag className="session-item__title">
                        {item.title ? item.title : item.id}
                      </TitleTag>
                      <span className="session-item__arrow" aria-hidden="true">
                        →
                      </span>
                    </div>

                    {item.description && (
                      <p className="session-item__description">
                        {item.description}
                      </p>
                    )}

                    <SessionChips item={item} />
                  </div>
                </div>
              </ConditionalLink>
            </div>
          );
        })}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

SessionTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkTitle: PropTypes.string,
  linkHref: PropTypes.arrayOf(PropTypes.any),
  isEditMode: PropTypes.bool,
  headlineTag: PropTypes.string,
};

export default SessionTemplate;
